import { Icon } from 'monday-ui-react-core'
import WarningIcon from './../../assest/images/exclamation-mark.svg'
import { Col, Container, Row } from 'react-bootstrap'

const Error = () => {
    return (
        <Container fluid>
            <Row className='mt-5'>
                <Col lg={1} className='d-flex mx-auto'>
                    <Icon
                        className='h-100'
                        iconType={Icon.type.SRC} 
                        icon={WarningIcon} />
                </Col>
            </Row>
            <Row className='d-flex justify-content-center mt-3'>
                <p className='w-50 text-center' style={{fontSize: '1.5rem'}}>
                    There was an error loading the information. Please, refresh the application or login back. If the issue persists, please contact your administrator.
                </p>
            </Row>
        </Container>
    )
}

export default Error